// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Player selection dialog — mobile-first, light/dark via theme tokens */

.psd-dlg.MuiDialog-root .MuiDialog-container {
  align-items: flex-end;
}

@media (min-width: 641px) {
  .psd-dlg.MuiDialog-root .MuiDialog-container {
    align-items: center;
  }
}

.psd-dlg__backdrop {
  background: rgba(15, 23, 42, 0.55) !important;
}

.dark-mode .psd-dlg__backdrop {
  background: rgba(0, 0, 0, 0.65) !important;
}

.psd-dlg__paper.MuiPaper-root,
.psd-dlg .MuiDialog-paper {
  margin: 0 !important;
  width: 100% !important;
  max-width: 100% !important;
  border-radius: 20px 20px 0 0 !important;
  background: var(--surface-color, #fff) !important;
  color: var(--text-color, #1a1a1a) !important;
  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));
  border-bottom: none;
  box-shadow: 0 -12px 40px rgba(0, 0, 0, 0.18);
  overflow: hidden;
  max-height: min(92dvh, 100%);
  display: flex !important;
  flex-direction: column !important;
}

.psd-dlg__paper--mobile.MuiPaper-root {
  border-radius: 0 !important;
  max-height: 100% !important;
  height: 100% !important;
  border: none;
  box-shadow: none;
}

@media (min-width: 641px) {
  .psd-dlg__paper.MuiPaper-root,
  .psd-dlg .MuiDialog-paper {
    margin: 24px !important;
    width: min(480px, calc(100vw - 32px)) !important;
    max-width: 480px !important;
    border-radius: 18px !important;
    border: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));
    box-shadow: 0 24px 64px rgba(0, 0, 0, 0.2);
    max-height: min(88vh, 760px);
  }
}

.dark-mode .psd-dlg__paper.MuiPaper-root,
.dark-mode .psd-dlg .MuiDialog-paper {
  border-color: rgba(255, 255, 255, 0.1);
  box-shadow: 0 -12px 40px rgba(0, 0, 0, 0.5);
}

.psd-dlg__shell {
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  max-height: inherit;
  background:
    radial-gradient(
      120% 80% at 0% 0%,
      rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12) 0%,
      transparent 55%
    ),
    var(--surface-color, #fff);
}

.psd-dlg__handle {
  width: 40px;
  height: 4px;
  margin: 10px auto 0;
  border-radius: 999px;
  background: color-mix(in srgb, var(--text-secondary, #9ca3af) 45%, transparent);
  flex-shrink: 0;
}

.psd-dlg__header {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 14px 16px 8px;
  flex-shrink: 0;
}

.psd-dlg__header-text {
  flex: 1 1;
  min-width: 0;
}

.psd-dlg__title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.25;
  color: var(--text-color, #111);
}

.psd-dlg__subtitle {
  margin: 4px 0 0;
  font-size: 0.78rem;
  color: var(--text-secondary, #6b7280);
}

.psd-dlg__close {
  color: var(--text-secondary, #6b7280) !important;
  background: color-mix(in srgb, var(--text-color) 6%, transparent) !important;
  border-radius: 10px !important;
  width: 36px !important;
  height: 36px !important;
}

.psd-dlg__close:hover {
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12) !important;
  color: var(--brand-primary, #0877BC) !important;
}

.psd-dlg__toolbar {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 16px 10px;
  flex-shrink: 0;
}

.psd-dlg__search {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 44px;
  padding: 0 12px;
  border-radius: 12px;
  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.1));
  background: color-mix(in srgb, var(--text-color) 5%, var(--surface-color, #fff));
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.psd-dlg__search:focus-within {
  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.55);
  box-shadow: 0 0 0 3px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.14);
}

.psd-dlg__search-icon {
  color: var(--text-secondary, #9ca3af) !important;
  flex-shrink: 0;
}

.psd-dlg__search-input {
  flex: 1 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  color: var(--text-color, #111);
  font-size: 0.95rem;
  font-family: inherit;
}

.psd-dlg__search-input::placeholder {
  color: var(--text-secondary, #9ca3af);
}

.psd-dlg__filters {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  padding-bottom: 2px;
}

.psd-dlg__filters::-webkit-scrollbar {
  display: none;
}

.psd-dlg__filter-chip {
  flex-shrink: 0;
  height: 32px;
  padding: 0 12px;
  border-radius: 999px;
  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.1));
  background: color-mix(in srgb, var(--text-color) 4%, var(--surface-color, #fff));
  color: var(--text-secondary, #6b7280);
  font-size: 0.78rem;
  font-weight: 650;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.psd-dlg__filter-chip.is-active {
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.14);
  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35);
  color: var(--brand-primary, #0877BC);
}

.psd-dlg__filter-chip:active {
  transform: scale(0.97);
}

.psd-dlg__bulk {
  display: flex;
  gap: 8px;
}

.psd-dlg__bulk-btn {
  flex: 1 1;
  height: 34px;
  border-radius: 10px;
  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.1));
  background: transparent;
  color: var(--brand-primary, #0877BC);
  font-size: 0.78rem;
  font-weight: 650;
  font-family: inherit;
  cursor: pointer;
}

.psd-dlg__bulk-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.psd-dlg__bulk-btn:not(:disabled):active {
  transform: scale(0.98);
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08);
}

.psd-dlg__body.MuiDialogContent-root {
  padding: 0 12px 8px !important;
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.psd-dlg__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 180px;
  padding: 24px;
  text-align: center;
  color: var(--text-secondary, #888);
  font-size: 0.9rem;
}

.psd-dlg__list {
  list-style: none;
  margin: 0;
  padding: 0 0 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.psd-dlg__row {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 14px;
  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));
  background: color-mix(in srgb, var(--text-color) 3%, var(--surface-color, #fff));
  color: inherit;
  text-align: left;
  font: inherit;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, transform 0.15s ease;
  min-height: 64px;
  -webkit-tap-highlight-color: transparent;
}

.dark-mode .psd-dlg__row {
  background: rgba(255, 255, 255, 0.03);
  border-color: rgba(255, 255, 255, 0.1);
}

.psd-dlg__row:hover {
  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35);
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.06);
}

.psd-dlg__row:active {
  transform: scale(0.985);
}

.psd-dlg__row.is-selected {
  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.5);
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);
}

.psd-dlg__check {
  display: inline-flex;
  color: var(--text-secondary, #9ca3af);
  flex-shrink: 0;
}

.psd-dlg__row.is-selected .psd-dlg__check {
  color: var(--brand-primary, #0877BC);
}

.psd-dlg__avatar {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  object-fit: cover;
  flex-shrink: 0;
  border: 2px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.25);
}

.psd-dlg__avatar--fallback {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.78rem;
  font-weight: 800;
  color: #fff;
  background: linear-gradient(
    135deg,
    var(--brand-primary, #0877BC),
    var(--brand-primary-light, #0a8cd8)
  );
  border: none;
}

.psd-dlg__row-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.psd-dlg__name {
  font-size: 0.92rem;
  font-weight: 650;
  color: var(--text-color, #111);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.psd-dlg__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.psd-dlg__badge {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  border-radius: 999px;
  font-size: 0.68rem;
  font-weight: 750;
  color: var(--brand-primary, #0877BC);
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);
}

.psd-dlg__points {
  font-size: 0.7rem;
  font-weight: 650;
  color: var(--text-secondary, #6b7280);
}

.psd-dlg__footer {
  flex-shrink: 0;
  display: flex;
  gap: 10px;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  border-top: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));
  background: color-mix(in srgb, var(--brand-primary, #0877BC) 4%, var(--surface-color, #fff));
}

.dark-mode .psd-dlg__footer {
  border-top-color: rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.02);
}

.psd-dlg__btn {
  flex: 1 1;
  height: 46px;
  border-radius: 12px;
  font-size: 0.9rem;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  border: none;
  transition: transform 0.15s ease, opacity 0.15s ease, background 0.15s ease;
}

.psd-dlg__btn:active {
  transform: scale(0.98);
}

.psd-dlg__btn--ghost {
  background: color-mix(in srgb, var(--text-color) 6%, transparent);
  color: var(--text-color, #111);
  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.1));
}

.psd-dlg__btn--primary {
  background: var(--brand-primary, #0877BC);
  color: #fff;
  box-shadow: 0 8px 18px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);
}

.psd-dlg__btn--primary:hover {
  background: var(--brand-primary-dark, #065a8f);
}

@media (min-width: 641px) {
  .psd-dlg__title {
    font-size: 1.2rem;
  }

  .psd-dlg__header {
    padding: 18px 18px 10px;
  }

  .psd-dlg__toolbar,
  .psd-dlg__body.MuiDialogContent-root {
    padding-left: 18px;
    padding-right: 18px;
  }

  .psd-dlg__footer {
    padding: 14px 18px;
  }

  .psd-dlg__btn--ghost {
    flex: 0 0 auto;
    min-width: 110px;
  }

  .psd-dlg__btn--primary {
    flex: 1 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AdminLayout/PlayerSelectionDialog.css"],"names":[],"mappings":"AAAA,wEAAwE;;AAExE;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;EAEE,oBAAoB;EACpB,sBAAsB;EACtB,0BAA0B;EAC1B,uCAAuC;EACvC,iDAAiD;EACjD,4CAA4C;EAC5C,0DAA0D;EAC1D,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;EAChB,4BAA4B;EAC5B,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;;IAEE,uBAAuB;IACvB,gDAAgD;IAChD,2BAA2B;IAC3B,8BAA8B;IAC9B,0DAA0D;IAC1D,0CAA0C;IAC1C,4BAA4B;EAC9B;AACF;;AAEA;;EAEE,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB;;;;;;8BAM4B;AAC9B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,+EAA+E;EAC/E,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,gDAAgD;EAChD,4EAA4E;EAC5E,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,wEAAwE;EACxE,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yDAAyD;EACzD,gFAAgF;EAChF,0DAA0D;AAC5D;;AAEA;EACE,+DAA+D;EAC/D,uEAAuE;AACzE;;AAEA;EACE,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,yDAAyD;EACzD,gFAAgF;EAChF,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,6DAA6D;EAC7D,+DAA+D;EAC/D,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,yDAAyD;EACzD,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,6DAA6D;AAC/D;;AAEA;EACE,8BAA8B;EAC9B,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,0DAA0D;EAC1D,gFAAgF;EAChF,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gFAAgF;EAChF,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,+DAA+D;EAC/D,6DAA6D;AAC/D;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8DAA8D;EAC9D,6DAA6D;AAC/D;;AAEA;EACE,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,mEAAmE;AACrE;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX;;;;GAIC;EACD,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,SAAS;EACT,2DAA2D;EAC3D,8DAA8D;EAC9D,4FAA4F;AAC9F;;AAEA;EACE,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,2EAA2E;AAC7E;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iEAAiE;EACjE,8BAA8B;EAC9B,yDAAyD;AAC3D;;AAEA;EACE,yCAAyC;EACzC,WAAW;EACX,wEAAwE;AAC1E;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,SAAO;EACT;AACF","sourcesContent":["/* Player selection dialog — mobile-first, light/dark via theme tokens */\n\n.psd-dlg.MuiDialog-root .MuiDialog-container {\n  align-items: flex-end;\n}\n\n@media (min-width: 641px) {\n  .psd-dlg.MuiDialog-root .MuiDialog-container {\n    align-items: center;\n  }\n}\n\n.psd-dlg__backdrop {\n  background: rgba(15, 23, 42, 0.55) !important;\n}\n\n.dark-mode .psd-dlg__backdrop {\n  background: rgba(0, 0, 0, 0.65) !important;\n}\n\n.psd-dlg__paper.MuiPaper-root,\n.psd-dlg .MuiDialog-paper {\n  margin: 0 !important;\n  width: 100% !important;\n  max-width: 100% !important;\n  border-radius: 20px 20px 0 0 !important;\n  background: var(--surface-color, #fff) !important;\n  color: var(--text-color, #1a1a1a) !important;\n  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));\n  border-bottom: none;\n  box-shadow: 0 -12px 40px rgba(0, 0, 0, 0.18);\n  overflow: hidden;\n  max-height: min(92dvh, 100%);\n  display: flex !important;\n  flex-direction: column !important;\n}\n\n.psd-dlg__paper--mobile.MuiPaper-root {\n  border-radius: 0 !important;\n  max-height: 100% !important;\n  height: 100% !important;\n  border: none;\n  box-shadow: none;\n}\n\n@media (min-width: 641px) {\n  .psd-dlg__paper.MuiPaper-root,\n  .psd-dlg .MuiDialog-paper {\n    margin: 24px !important;\n    width: min(480px, calc(100vw - 32px)) !important;\n    max-width: 480px !important;\n    border-radius: 18px !important;\n    border: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));\n    box-shadow: 0 24px 64px rgba(0, 0, 0, 0.2);\n    max-height: min(88vh, 760px);\n  }\n}\n\n.dark-mode .psd-dlg__paper.MuiPaper-root,\n.dark-mode .psd-dlg .MuiDialog-paper {\n  border-color: rgba(255, 255, 255, 0.1);\n  box-shadow: 0 -12px 40px rgba(0, 0, 0, 0.5);\n}\n\n.psd-dlg__shell {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  height: 100%;\n  max-height: inherit;\n  background:\n    radial-gradient(\n      120% 80% at 0% 0%,\n      rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12) 0%,\n      transparent 55%\n    ),\n    var(--surface-color, #fff);\n}\n\n.psd-dlg__handle {\n  width: 40px;\n  height: 4px;\n  margin: 10px auto 0;\n  border-radius: 999px;\n  background: color-mix(in srgb, var(--text-secondary, #9ca3af) 45%, transparent);\n  flex-shrink: 0;\n}\n\n.psd-dlg__header {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 14px 16px 8px;\n  flex-shrink: 0;\n}\n\n.psd-dlg__header-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.psd-dlg__title {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n  color: var(--text-color, #111);\n}\n\n.psd-dlg__subtitle {\n  margin: 4px 0 0;\n  font-size: 0.78rem;\n  color: var(--text-secondary, #6b7280);\n}\n\n.psd-dlg__close {\n  color: var(--text-secondary, #6b7280) !important;\n  background: color-mix(in srgb, var(--text-color) 6%, transparent) !important;\n  border-radius: 10px !important;\n  width: 36px !important;\n  height: 36px !important;\n}\n\n.psd-dlg__close:hover {\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12) !important;\n  color: var(--brand-primary, #0877BC) !important;\n}\n\n.psd-dlg__toolbar {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 0 16px 10px;\n  flex-shrink: 0;\n}\n\n.psd-dlg__search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 44px;\n  padding: 0 12px;\n  border-radius: 12px;\n  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.1));\n  background: color-mix(in srgb, var(--text-color) 5%, var(--surface-color, #fff));\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.psd-dlg__search:focus-within {\n  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.55);\n  box-shadow: 0 0 0 3px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.14);\n}\n\n.psd-dlg__search-icon {\n  color: var(--text-secondary, #9ca3af) !important;\n  flex-shrink: 0;\n}\n\n.psd-dlg__search-input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  outline: none;\n  background: transparent;\n  color: var(--text-color, #111);\n  font-size: 0.95rem;\n  font-family: inherit;\n}\n\n.psd-dlg__search-input::placeholder {\n  color: var(--text-secondary, #9ca3af);\n}\n\n.psd-dlg__filters {\n  display: flex;\n  gap: 8px;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n  padding-bottom: 2px;\n}\n\n.psd-dlg__filters::-webkit-scrollbar {\n  display: none;\n}\n\n.psd-dlg__filter-chip {\n  flex-shrink: 0;\n  height: 32px;\n  padding: 0 12px;\n  border-radius: 999px;\n  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.1));\n  background: color-mix(in srgb, var(--text-color) 4%, var(--surface-color, #fff));\n  color: var(--text-secondary, #6b7280);\n  font-size: 0.78rem;\n  font-weight: 650;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n.psd-dlg__filter-chip.is-active {\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.14);\n  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35);\n  color: var(--brand-primary, #0877BC);\n}\n\n.psd-dlg__filter-chip:active {\n  transform: scale(0.97);\n}\n\n.psd-dlg__bulk {\n  display: flex;\n  gap: 8px;\n}\n\n.psd-dlg__bulk-btn {\n  flex: 1;\n  height: 34px;\n  border-radius: 10px;\n  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.1));\n  background: transparent;\n  color: var(--brand-primary, #0877BC);\n  font-size: 0.78rem;\n  font-weight: 650;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.psd-dlg__bulk-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.psd-dlg__bulk-btn:not(:disabled):active {\n  transform: scale(0.98);\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08);\n}\n\n.psd-dlg__body.MuiDialogContent-root {\n  padding: 0 12px 8px !important;\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.psd-dlg__empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 180px;\n  padding: 24px;\n  text-align: center;\n  color: var(--text-secondary, #888);\n  font-size: 0.9rem;\n}\n\n.psd-dlg__list {\n  list-style: none;\n  margin: 0;\n  padding: 0 0 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.psd-dlg__row {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  border-radius: 14px;\n  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));\n  background: color-mix(in srgb, var(--text-color) 3%, var(--surface-color, #fff));\n  color: inherit;\n  text-align: left;\n  font: inherit;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease, transform 0.15s ease;\n  min-height: 64px;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.dark-mode .psd-dlg__row {\n  background: rgba(255, 255, 255, 0.03);\n  border-color: rgba(255, 255, 255, 0.1);\n}\n\n.psd-dlg__row:hover {\n  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35);\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.06);\n}\n\n.psd-dlg__row:active {\n  transform: scale(0.985);\n}\n\n.psd-dlg__row.is-selected {\n  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.5);\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);\n}\n\n.psd-dlg__check {\n  display: inline-flex;\n  color: var(--text-secondary, #9ca3af);\n  flex-shrink: 0;\n}\n\n.psd-dlg__row.is-selected .psd-dlg__check {\n  color: var(--brand-primary, #0877BC);\n}\n\n.psd-dlg__avatar {\n  width: 42px;\n  height: 42px;\n  border-radius: 12px;\n  object-fit: cover;\n  flex-shrink: 0;\n  border: 2px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.25);\n}\n\n.psd-dlg__avatar--fallback {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.78rem;\n  font-weight: 800;\n  color: #fff;\n  background: linear-gradient(\n    135deg,\n    var(--brand-primary, #0877BC),\n    var(--brand-primary-light, #0a8cd8)\n  );\n  border: none;\n}\n\n.psd-dlg__row-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.psd-dlg__name {\n  font-size: 0.92rem;\n  font-weight: 650;\n  color: var(--text-color, #111);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.psd-dlg__meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n}\n\n.psd-dlg__badge {\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  padding: 0 8px;\n  border-radius: 999px;\n  font-size: 0.68rem;\n  font-weight: 750;\n  color: var(--brand-primary, #0877BC);\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);\n}\n\n.psd-dlg__points {\n  font-size: 0.7rem;\n  font-weight: 650;\n  color: var(--text-secondary, #6b7280);\n}\n\n.psd-dlg__footer {\n  flex-shrink: 0;\n  display: flex;\n  gap: 10px;\n  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));\n  border-top: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));\n  background: color-mix(in srgb, var(--brand-primary, #0877BC) 4%, var(--surface-color, #fff));\n}\n\n.dark-mode .psd-dlg__footer {\n  border-top-color: rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.psd-dlg__btn {\n  flex: 1;\n  height: 46px;\n  border-radius: 12px;\n  font-size: 0.9rem;\n  font-weight: 700;\n  font-family: inherit;\n  cursor: pointer;\n  border: none;\n  transition: transform 0.15s ease, opacity 0.15s ease, background 0.15s ease;\n}\n\n.psd-dlg__btn:active {\n  transform: scale(0.98);\n}\n\n.psd-dlg__btn--ghost {\n  background: color-mix(in srgb, var(--text-color) 6%, transparent);\n  color: var(--text-color, #111);\n  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.1));\n}\n\n.psd-dlg__btn--primary {\n  background: var(--brand-primary, #0877BC);\n  color: #fff;\n  box-shadow: 0 8px 18px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);\n}\n\n.psd-dlg__btn--primary:hover {\n  background: var(--brand-primary-dark, #065a8f);\n}\n\n@media (min-width: 641px) {\n  .psd-dlg__title {\n    font-size: 1.2rem;\n  }\n\n  .psd-dlg__header {\n    padding: 18px 18px 10px;\n  }\n\n  .psd-dlg__toolbar,\n  .psd-dlg__body.MuiDialogContent-root {\n    padding-left: 18px;\n    padding-right: 18px;\n  }\n\n  .psd-dlg__footer {\n    padding: 14px 18px;\n  }\n\n  .psd-dlg__btn--ghost {\n    flex: 0 0 auto;\n    min-width: 110px;\n  }\n\n  .psd-dlg__btn--primary {\n    flex: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
